import { axiosConvert, axiosPassport, axiosMember } from "@/utils/axios";

// history - post
export const historyPost = (url, params, config) => axiosConvert.post(url, params, config);
// history - get
export const historyGet = (url, params) => axiosConvert.get(url, params);
// passport- get
export const passportGet = (url, params) => axiosPassport.get(url, params);
// passport- post
export const passportPost = (url, params, config) => axiosPassport.post(url, params, config);
// member- post
export const vipPost = (url, params, config) => axiosMember.post(url, params, config);
